import { WSPanel } from "@wingspanhq/fe-component-library";
import { DefinitionDataSourceType } from "@wingspanhq/payments/dist/interfaces";
import {
  ISignedDocumentTemplateCreateRequest,
  ISignedDocumentTemplateResponse,
  SignerRole
} from "@wingspanhq/signed-documents/dist/lib/interfaces";
import * as Yup from "yup";

import { CreateSignaturePartialForm } from "../../../../modules/Signature/createRequirementDefinition/CreateSignaturePartialForm";
import { RequirementDefinitionSignatureFormValues } from "../../../../types";
import { RequirementDefinitionTemplateForm } from "../../types";

export const STANDARD_ESIGNATURE_FORM: RequirementDefinitionTemplateForm<
  ISignedDocumentTemplateResponse,
  RequirementDefinitionSignatureFormValues,
  ISignedDocumentTemplateCreateRequest
> = {
  getDefaultSettingsValues: template => ({
    fileId: "",
    requiredSignatures: "collaborator",
    signedDocumentTemplateId: ""
  }),
  getEditSettingsValues(template, requirementDefinition, settings) {
    const requiredSignatures = settings.roles?.includes(SignerRole.Payer)
      ? "mutual"
      : "collaborator";

    return {
      fileId: settings.fileId,
      requiredSignatures,
      signedDocumentTemplateId: settings.signedDocumentTemplateId
    };
  },
  mapDataSourceResponseToRequirementCreateRequest(response) {
    return {
      dataSourceId: response.signedDocumentTemplateId,
      dataSourceType: DefinitionDataSourceType.SignedDocumentTemplate
    };
  },
  mapFormDataToDataSourceCreateRequest(formValues) {
    return {
      fileId: formValues.fileId,
      roles:
        formValues.requiredSignatures === "collaborator"
          ? [SignerRole.Payee]
          : [SignerRole.Payee, SignerRole.Payer],
      title: formValues.name,
      userId: formValues.clientId
    };
  },
  mapFormDataToRequirementCreateRequest(formValues) {
    return {
      dataSourceId: formValues.signedDocumentTemplateId,
      dataSourceType: DefinitionDataSourceType.SignedDocumentTemplate
    };
  },
  partialForm: (
    <WSPanel>
      <CreateSignaturePartialForm />
    </WSPanel>
  ),
  successCreationMessage: "Requirement created successfully",
  validationSchema: Yup.object().shape({
    fileId: Yup.string().required("Required"),
    requiredSignatures: Yup.string()
      .oneOf(["collaborator", "mutual"])
      .required("Required") as Yup.AnySchema,
    signedDocumentTemplateId: Yup.string().required("Required")
  })
};
